import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import { followCommunity } from 'src/modules/community/shared/actions';
import Pagination from 'src/components/pagination/pagination';
import EmptySearchResults from 'src/modules/search/shared/components/emptySearchResults';
import SearchCommunityCard from 'src/modules/search/communities/components/searchCommunityCard';
import CommunityCardLoader from 'src/modules/search/communities/components/communityCardLoader';
import paginationResultsPerPage from 'src/constants/paginationResultsPerPage';
import FollowSuccessMessage from 'src/modules/community/shared/components/alert/followSuccessMessage';

export default function SearchCommunitiesList() {
  const dispatch = useDispatch();
  const {
    communityResults,
    searchQuery = null,
    totalResults = 0,
    isLoading,
    searchId = null,
  } = useSelector(({ pages }) => pages.search);

  const onCommunityClick = (communityId) => {
    trackFootfallEvent(Event.CLICKED_SEARCH_RESULT, {
      clickType: 'community-result',
      clickMetadata: { communityId, 'link-type': 'community', searchId },
    });
  };

  const onFollowCommunity = async (community) => {
    await dispatch(followCommunity({
      communitySlug: community.slug,
      successMessage: <FollowSuccessMessage communityName={community.name} />,
    }));
  };

  return (
    <PageContainer>
      {communityResults.length === 0
        ? (
          isLoading
            ? <CommunityCardLoader />
            : (
              <EmptySearchResults
                isFiltered={false}
                query={searchQuery}
                searchType="communities"
              />
            )
        ) : (
          <>
            <div>
              <div className="search__summary-row" data-testid="search-summary-row">
                {Number(totalResults).toLocaleString() + (totalResults === 1 ? i18n.t(' public community') : i18n.t(' public communities'))}
              </div>
              <List>
                {communityResults.map(community => (
                  <SearchCommunityCard
                    community={community}
                    key={`community-card-${community.communityId}`}
                    onCommunityClick={onCommunityClick}
                    onFollowCommunity={onFollowCommunity}
                  />
                ))}
              </List>
            </div>
            <Pagination
              pageSize={paginationResultsPerPage.searchCommunities}
              total={totalResults}
            />
          </>
        )}
    </PageContainer>
  );
}

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px;
  @media (${({ theme }) => theme.underScreenXlarge}) and (${({ theme }) => theme.overScreenSmall}) {
    margin: 0 20px;
  }
  @media (${({ theme }) => theme.underScreenSmall}) {
    padding: 0;
  }

  .search__no-results {
    @media (${({ theme }) => theme.overScreenSmall}) {
      max-width: 700px;
    }
    @media (${({ theme }) => theme.underScreenSmall}) {
      padding: 0 15px;
    }
  }
  .search-tips {
    @media (${({ theme }) => theme.underScreenSmall}) {
      padding: 15px 0;
    }
  }
  .community-card-loader__list {
    @media (${({ theme }) => theme.underScreenSmall}) {
      padding: 0 15px;
    }
  }
`;

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  @media (${({ theme }) => theme.underScreenSmall}) {
    padding: 0 15px;
  }
`;
